"use client";

import { Eye } from "lucide-react";
import Link from "next/link";
import { Skeleton } from "@/shadcn/ui/skeleton";
import { useShowRowContext } from "@/components/shows/ShowRowContext";

export function ShowRowUsersChecking({ showId }: { showId: string }) {
  const {
    usersChecking,
    badgesLoading: loading,
    hideUsersChecking,
  } = useShowRowContext();

  if (hideUsersChecking) {
    return null;
  }

  const formatUsersCheckingValue = (usersChecking: number) => {
    // if the number of users checking is greater than 1000, show "1.2K"
    if (usersChecking > 1000) {
      return `${(usersChecking / 1000).toFixed(1)}K`;
    }
    return usersChecking;
  };

  if (loading) {
    return <Skeleton className="w-[122px] h-[18px]" />;
  }

  if (usersChecking === 0) {
    return null;
  }

  return (
    <Link
      href={`/e/${showId}`}
      className="flex items-center gap-1 text-xs font-medium text-secondary-blue"
    >
      <Eye className="w-3.5 h-3.5" />
      {formatUsersCheckingValue(usersChecking)} fans interested
    </Link>
  );
}
